import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const removeDashboard = (id, afterRequest:any = null) => ({
  type: types.REMOVE_DASHBOARD,
  id,
  afterRequest,
});

export const removeDashboardById = (id, isDefault) => ({
  type: types.REMOVE_DASHBOARD_BY_ID,
  id,
  isDefault,
});


const { init: initRequest, fetching } = createAllActions(types.SCOPE);

export { initRequest, fetching };
